import React, { useState } from "react";
import { useExpandableRowsGrid, usePagination } from "../../../../../hooks";
import { sortGridByColumn } from "../../../../../utils";
import { Grid, GridRowExpandable } from "../../../../../components";
import {
  RLCSYaraEntry,
  SortParams,
  YARAItemSchema
} from "../../../@types/rldynamicanalysis/yara";
import RLCloudSandboxYaraMatches from "./RLCloudSandboxYaraMatches";

type RLCSCloudSandboxYaraGridProps = {
  yaraData: RLCSYaraEntry[];
  schema: YARAItemSchema;
};

const RLCloudSandboxYaraGrid = ({
  yaraData,
  schema
}: RLCSCloudSandboxYaraGridProps) => {
  const { data, currentPageData, updatePageData } = usePagination(yaraData, {
    pageSize: 20
  });

  const [sort, setSort] = useState({
    field: "default",
    direction: "asc"
  });

  const {
    expandedRows,
    handleCheckRowExpanded,
    handleRowExpandedChange,
    resetExpandedRows
  } = useExpandableRowsGrid(currentPageData.page ?? 1);

  const handlePageChange = (newPage: number, newPageSize?: number): void => {
    resetExpandedRows();
    updatePageData({ newPage, newPageSize });
  };

  const handleSortChange = (sortParams: SortParams) => {
    const { field, direction } = sort;
    if (sortParams.direction === direction && sortParams.field === field)
      return;
    setSort(sortParams);
    sortGridByColumn(data, sortParams);
  };

  return (
    <Grid
      schema={schema}
      data={data}
      totalResults={yaraData.length}
      page={currentPageData.page}
      pageSize={currentPageData.pageSize}
      onPageChange={handlePageChange}
      numPages={currentPageData.numPages}
      showPageNumbers
      sort={sort}
      onSortChange={handleSortChange}
      rowClassName={() => "row-expandable-with-expand-cell"}
      expandedRowColumns={schema.fields.length}
      expandedRows={expandedRows}
      checkRowExpanded={handleCheckRowExpanded}
      renderExpandedRow={RLCloudSandboxYaraMatches}
      onRowExpandedChange={handleRowExpandedChange}
      GridRowComponent={GridRowExpandable}
    />
  );
};

export default RLCloudSandboxYaraGrid;
